import { Mail, UserCheck, UserPlus } from 'lucide-react';
import type { BulkCareSeekerOutcome } from '../../../../types/bulk-referral.type';

type CareSeekerBadgeProps = {
  outcome: BulkCareSeekerOutcome;
  willSendInvite: boolean;
};

// Amber (not red): creating a contact and inviting are expected effects, not errors.
const OUTCOME_CONFIG = {
  USER: { label: 'bQuest user', icon: UserCheck, className: 'bg-gray-100 text-gray-700' },
  REUSED: { label: 'off-platform · known contact', icon: UserCheck, className: 'bg-blue-50 text-blue-700' },
  CREATED: { label: 'off-platform · will be created', icon: UserPlus, className: 'bg-amber-50 text-amber-800' },
  NONE: { label: 'none declared', icon: null, className: 'bg-gray-100 text-gray-500' },
} as const;

export const CareSeekerBadge = ({ outcome, willSendInvite }: CareSeekerBadgeProps) => {
  if (outcome === 'UNRESOLVED') return null;

  const config = OUTCOME_CONFIG[outcome];
  const Icon = config.icon;

  return (
    <span className="inline-flex flex-wrap items-center gap-1">
      <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${config.className}`}>
        {Icon && <Icon className="h-3 w-3" aria-hidden />}
        {config.label}
      </span>
      {outcome === 'CREATED' && willSendInvite && (
        <span className="inline-flex items-center gap-1 rounded-full bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-800">
          <Mail className="h-3 w-3" aria-hidden />+ invite
        </span>
      )}
    </span>
  );
};
